import React from "react";
import { useUserContext } from "context/UserContext";
import { isManagementRoleLevel, normalizeRoleLevel } from "utils/roleUtils";
import MachineBootstrapSetupBK from "layouts/BK/machineBootstrapSetup";

function MachineBootstrapSetup() {
  const { roleLevel } = useUserContext() || {};
  if (isManagementRoleLevel(normalizeRoleLevel(roleLevel))) {
    return <MachineBootstrapSetupBK />;
  }
  return null;
}

export default MachineBootstrapSetup;
